module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0410-7b1eda8969c099817b9cdd05c9e15e32.jpg";